import { z } from 'zod';

import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const modelPriceSchema = z.object({
	model: z.string(),
	inputPerMTok: z.number().nonnegative(),
	outputPerMTok: z.number().nonnegative(),
});

export const pricingResponse = z.object({ items: z.array(modelPriceSchema) });

export type ModelPrice = z.infer<typeof modelPriceSchema>;
export type UsePricing = ZodUseQuery<z.infer<typeof pricingResponse>>;
